import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useHistory, Link, useParams } from 'react-router-dom';
import { Breadcrumb, message } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import {
  UPDATE_PROJECT_TYPE,
  GET_PROJECT_TYPES,
} from '../../../gql/projectTypes';
import { useLoading } from '../../../hooks';
import ProjectTypeForm from './components/ProjectTypeForm';

const EditProjectType = () => {
  const { id } = useParams();
  const history = useHistory();
  const { data, loading } = useQuery(GET_PROJECT_TYPES, {
    variables: { ids: [id], state: 'ALL' },
  });
  const [updateProjectType, { loading: mutationLoading }] = useMutation(
    UPDATE_PROJECT_TYPE,
    {
      refetchQueries: [
        { query: GET_PROJECT_TYPES, variables: { ids: [id], state: 'ALL' } },
        { query: GET_PROJECT_TYPES, variables: { ids: [id], state: 'ACTIVE' } },
      ],
      onCompleted: ({ updateProjectType }) => {
        history.push('/system-setting/project-types');
        message.success(
          `Project Type ${updateProjectType.name} successfully edited`
        );
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );
  useLoading(mutationLoading);

  const onFinish = ({ name, description, active, seq }) => {
    updateProjectType({
      variables: {
        input: {
          id,
          name,
          description,
          seq,
          disabled: !active,
          deleted: false,
        },
      },
    });
  };

  const initialValues = data?.projectTypes[0];

  return (
    <PageContainer
      loading={loading}
      header={{
        title: 'Edit Project Type',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/project-types">Project Types</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Edit Project Type</Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
    >
      <ProjectTypeForm
        onFinish={onFinish}
        initialValues={initialValues}
        isEdit={true}
      />
    </PageContainer>
  );
};

export default EditProjectType;
